import * as client from "../../services/client";
import { TYPES } from "../../common/constants";
import { startPRLoading, stopPRLoading } from "./loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const fetchWalkThroughsDone = (payload) => ({
  type: TYPES.FETCH_WALK_THROUGHS_DONE,
  payload,
});

export const fetchSuiteWalkThroughs =
  (suiteId, roleName, loader) => (dispatch) => {
    if (loader === true) {
      dispatch(startPRLoading());
    }
    return client
      .fetchSuiteWalkThroughs(suiteId, roleName)
      .then((response) => {
        if (response.status === 200 && response.ok) {
          response.json().then((responsejson) => {
            dispatch(stopPRLoading());
            dispatch(fetchWalkThroughsDone(responsejson.data));
          });
        } else {
          dispatch(fetchWalkThroughsDone([]));
          dispatch(stopPRLoading());
          toast.error(" 🚫 Something went wrong, please try again.", {
            autoClose: 3000,
            position: "top-center",
          });
        }
      })
      .catch(() => {
        dispatch(fetchWalkThroughsDone([]));
        dispatch(stopPRLoading());
        toast.error(" 🚫 Something went wrong, please try again.", {
          autoClose: 3000,
          position: "top-center",
        });
      });
  };